export default (params) => ({
  trigger: {
    name: 'product_type_section.change_quantity',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
      type: {
        enum: [
          'add',
          'remove',
        ],
      },
      quantity: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'product_type_section',
          'product_type_section_alternative_overlay',
        ],
      },
    },
    event: {
      name: 'change_quantity',
    },
  },
});
